/**
 * Production stub — Trace renders nothing in production builds.
 * Zero runtime cost, zero bundle size impact.
 */
const Trace = () => null
export default Trace

export type { TraceAllInOneProps, EditorPreset } from './index'
